import { render, staticRenderFns } from "./ContainerStatusColorIcon.vue?vue&type=template&id=512b786f&scoped=true"
import script from "./ContainerStatusColorIcon.vue?vue&type=script&lang=js"
export * from "./ContainerStatusColorIcon.vue?vue&type=script&lang=js"
import style0 from "./ContainerStatusColorIcon.vue?vue&type=style&index=0&id=512b786f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b786f",
  null
  
)

export default component.exports